<template>
  <div class="tabs-container">
    <div class="tab-header">
      <div v-for="(option, index) in options" :key="index" @click="setActive(option)" class="tab-title" :class="{
        active: option === currentActive,
        'highlight-red': highlightRed.includes(option),
      }">
        <span>{{ option }}</span>
      </div>
    </div>

    <div class="tab-content">
      <div v-for="option in options" :key="currentActive + '-' + option" class="tab-content-item"
        :class="{ active: option === currentActive }">
        <slot :name="option"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    options: {
      type: Array,
      required: true,
    },
    highlightRed: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.setActive(this.options[0])
  },
  data() {
    return {
      currentActive: '',
    }
  },
  methods: {
    setActive(option) {
      this.currentActive = option
      this.$emit('handle:change', option)
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .tab-header {
    display: flex;
    flex-wrap: wrap;

    .tab-title {
      min-width: 10rem;
      flex: 1;
      padding: 0.5rem;
      border-bottom: 0.8px solid #eaeaea;

      display: flex;
      align-items: center;
      justify-content: center;

      font-weight: 400;
      color: #818181;

      cursor: pointer;

      transition: all 0.3s ease;

      &.active {
        border-width: 1px;
        border-color: #1c2d5a;
        font-size: 1rem;
        font-weight: 700;
        color: #1c2d5a;
      }

      span {
        white-space: nowrap;
      }
    }

    .tab-title.highlight-red {
      color: #e91d23;

      &.active {
        color: #cc1419;
        border-color: #cc1419;
      }
    }
  }

  .tab-content {
    .tab-content-item {
      display: none;
    }

    .active {
      display: block !important;
    }
  }
}
</style>
